// you MUST send to MANDRILL
import { VarKey } from "../Variables/Generated/VarKey.Data";

export interface EmailTemplate {
  name: string; // The template slug as it appears in mandrill

  templateDisplayName: string; // how it will appear for you

  mergeFields: {
    [id: string]: {
      fieldName: string; // the name of the field as it appears in the mail chimp

      displayName: string; // how it will appear for you

      defaultVariableOrValue: string; // the default value or variable, make sure to add #* *# as needed
    };
  };
}

export const EmailTemplates: EmailTemplate[] = [
  {
    name: "fms-contact-information-review",

    templateDisplayName: "FMS+: Contact Information Review",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      storephone: {
        fieldName: "StorePhone",

        displayName: "Store Phone",

        defaultVariableOrValue: `#*${VarKey.LocationPhone}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      userunitsize: {
        fieldName: "UnitDimensions",

        displayName: "User Unit Size",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      updatecontactinformationurl: {
        fieldName: "UpdateContactInformationURL",

        displayName: "Update Contact Information URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true&swivlStartOnQuest=#*${VarKey.LocationAfterNavigateAccountLoginUpdateContactQuestSlug}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-gate-code",

    templateDisplayName: "FMS+: Gate Code",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.OrgName}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      useraccesscode: {
        fieldName: "UserAccessCode",

        displayName: "Access/Gate Code",

        defaultVariableOrValue: `#*${VarKey.UserAccessCode}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-davinci-code",

    templateDisplayName: "FMS+: Davinci Code",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.OrgName}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      userdavincicode: {
        fieldName: "UserDavinciCode",

        displayName: "Davinci Code",

        defaultVariableOrValue: `#*${VarKey.UserDaVinciCode}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-account-balance",

    templateDisplayName: "FMS+: Account Balance",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      userunitsize: {
        fieldName: "UserUnitSize",

        displayName: "User Unit Size",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      balancedue: {
        fieldName: "BalanceDue",

        displayName: "Balance Due",

        defaultVariableOrValue: `#*${VarKey.LeaseBalance}*#`,
      },

      payonlineurl: {
        fieldName: "PayOnlineURL",

        displayName: "Pay Online URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true&swivlStartOnQuest=#*${VarKey.LocationAfterNavigateAccountLoginPayBillQuestSlug}*#`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-unit-number",

    templateDisplayName: "FMS+: Unit Number",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-generic",

    templateDisplayName: "FMS+: Generic",

    mergeFields: {
      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-move-in",

    templateDisplayName: "FMS+: Move-In",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      userunitsize: {
        fieldName: "UnitDimensions",

        displayName: "User Unit Size",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      useraccesscode: {
        fieldName: "UserAccessCode",

        displayName: "Access/Gate Code",

        defaultVariableOrValue: `#*${VarKey.UserAccessCode}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-move-in-no-access-code",

    templateDisplayName: "FMS+: Move-In without Access Code",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      userunitsize: {
        fieldName: "UnitDimensions",

        displayName: "User Unit Size",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-move-out",

    templateDisplayName: "FMS+: Move-Out",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      userunitsize: {
        fieldName: "UnitDimensions",

        displayName: "User Unit Size",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      useraccesscode: {
        fieldName: "UserAccessCode",

        displayName: "Access/Gate Code",

        defaultVariableOrValue: `#*${VarKey.UserAccessCode}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-payment-method-expiring",

    templateDisplayName: "FMS+: Payment Method Expiring",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      storephone: {
        fieldName: "StorePhone",

        displayName: "Store Phone",

        defaultVariableOrValue: `#*${VarKey.LocationPhone}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      userunitsize: {
        fieldName: "UnitDimensions",

        displayName: "User Unit Size",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      updatepaymentmethodurl: {
        fieldName: "UpdatePaymentMethodURL",

        displayName: "Update Payment MethodURL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true&swivlStartOnQuest=#*${VarKey.LocationAfterNavigateAccountLoginUpdateBillingQuestSlug}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-payment-past-due",

    templateDisplayName: "FMS+: Payment Past Due",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      userunitsize: {
        fieldName: "UnitDimensions",

        displayName: "User Unit Size",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      balancedue: {
        fieldName: "BalanceDue",

        displayName: "Balance Due",

        defaultVariableOrValue: `#*${VarKey.LeaseBalance}*#`,
      },

      payonlineurl: {
        fieldName: "PayOnlineURL",

        displayName: "Pay Online URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true&swivlStartOnQuest=#*${VarKey.LocationAfterNavigateAccountLoginPayBillQuestSlug}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-payment-reminder",

    templateDisplayName: "FMS+: Payment Reminder",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      userunitsize: {
        fieldName: "UnitDimensions",

        displayName: "User Unit Size",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      balancedue: {
        fieldName: "BalanceDue",

        displayName: "Balance Due",

        defaultVariableOrValue: `#*${VarKey.LeaseBalance}*#`,
      },

      payonlineurl: {
        fieldName: "PayOnlineURL",

        displayName: "Pay Online URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true&swivlStartOnQuest=#*${VarKey.LocationAfterNavigateAccountLoginPayBillQuestSlug}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-payment-success",

    templateDisplayName: "FMS+: Payment Success",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      userunitsize: {
        fieldName: "UnitDimensions",

        displayName: "User Unit Size",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-review-solicitation-gated",

    templateDisplayName: "FMS+: Review Solicitation (Gated)",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      reviewdetractorurl: {
        fieldName: "ReviewDetractorURL",

        displayName: "Review Detractor URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true&swivlStartOnQuest=#*${VarKey.LocationSpotReviewQuestSlug}*#`,
      },

      reviewpromoterurl: {
        fieldName: "ReviewPromoterURL",

        displayName: "Review Promoter URL",

        defaultVariableOrValue: `#*${VarKey.LocationGoogleReviewURL}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-review-solicitation-non-gated",

    templateDisplayName: "FMS+: Review Solicitation (Non Gated)",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      reviewsolicitationurl: {
        fieldName: "ReviewSolicitationURL",

        displayName: "Review Solicitation URL",

        defaultVariableOrValue: `#*${VarKey.LocationGoogleReviewURL}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "rating-solicitation-move-in",

    templateDisplayName: "Rating Solicitation: Move-in",

    //Need to edit

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      reviewdetractorurl: {
        fieldName: "ReviewDetractorURL",

        displayName: "Review Detractor URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true&swivlStartOnQuest=#*${VarKey.LocationSpotReviewQuestSlug}*#`,
      },

      reviewpromoterurl: {
        fieldName: "ReviewPromoterURL",

        displayName: "Review Promoter URL",

        defaultVariableOrValue: `#*${VarKey.LocationGoogleReviewURL}*#`,
      },
      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "receipt-detractor-rating",

    templateDisplayName: "Receipt: Detractor Rating",

    //Need to edit

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userreviewnpsfeedback: {
        fieldName: "UserReviewNPSFeedback",

        displayName: "User Review NPS Feedback",

        defaultVariableOrValue: `#*${VarKey.UserReviewNPSFeedback}*#`,
      },

      userreviewnpsscore: {
        fieldName: "UserReviewNPSScore",

        displayName: "User Review NPS Score",

        defaultVariableOrValue: `#*${VarKey.UserReviewNPSScore}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userpostalcode: {
        fieldName: "UserPostalCode",

        displayName: "User Postal Code",

        defaultVariableOrValue: `#*${VarKey.UserPostalCode}*#`,
      },

      usercurrenturl: {
        fieldName: "UserCurrentURL",

        displayName: "User Current URL",

        defaultVariableOrValue: `#*${VarKey.UserCurrentURL}*#`,
      },

      transcripturl: {
        fieldName: "TranscriptURL",

        displayName: "Transcript URL",

        defaultVariableOrValue: `https://v3.swivl.studio/transcript/#*${VarKey.UserId}*#`,
      },

      conversationurl: {
        fieldName: "ConversationURL",

        displayName: "Conversation URL",

        defaultVariableOrValue: `https://v3.swivl.studio/conversations/all/#*${VarKey.UserId}*#`,
      },

      storeemail: {
        fieldName: "StoreEmail",

        displayName: "Store Email",

        defaultVariableOrValue: `#*${VarKey.LocationEmail}*#`,
      },

      storedmemail: {
        fieldName: "StoreDMEmail",

        displayName: "Store DM Email",

        defaultVariableOrValue: `#*${VarKey.LocationDMEmail}*#`,
      },

      operatoremaillist: {
        fieldName: "OperatorEmailList",

        displayName: "Operator Email List",

        defaultVariableOrValue: `#*${VarKey.LocationswivlLeadEmailList}*#`,
      },
    },
  },

  {
    name: "receipt-promoter-rating",

    templateDisplayName: "Receipt: Promoter Rating",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      userreviewnpsfeedback: {
        fieldName: "UserReviewNPSFeedback",

        displayName: "User Review NPS Feedback",

        defaultVariableOrValue: `#*${VarKey.UserReviewNPSFeedback}*#`,
      },

      userreviewnpsscore: {
        fieldName: "UserReviewNPSScore",

        displayName: "User Review NPS Score",

        defaultVariableOrValue: `#*${VarKey.UserReviewNPSScore}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userpostalcode: {
        fieldName: "UserPostalCode",

        displayName: "User Postal Code",

        defaultVariableOrValue: `#*${VarKey.UserPostalCode}*#`,
      },

      usercurrenturl: {
        fieldName: "UserCurrentURL",

        displayName: "User Current URL",

        defaultVariableOrValue: `#*${VarKey.UserCurrentURL}*#`,
      },

      transcripturl: {
        fieldName: "TranscriptURL",

        displayName: "Transcript URL",

        defaultVariableOrValue: `https://v3.swivl.studio/transcript/#*${VarKey.UserId}*#`,
      },

      conversationurl: {
        fieldName: "ConversationURL",

        displayName: "Conversation URL",

        defaultVariableOrValue: `https://v3.swivl.studio/conversations/all/#*${VarKey.UserId}*#`,
      },

      storeemail: {
        fieldName: "StoreEmail",

        displayName: "Store Email",

        defaultVariableOrValue: `#*${VarKey.LocationEmail}*#`,
      },

      storedmemail: {
        fieldName: "StoreDMEmail",

        displayName: "Store DM Email",

        defaultVariableOrValue: `#*${VarKey.LocationDMEmail}*#`,
      },

      operatoremaillist: {
        fieldName: "OperatorEmailList",

        displayName: "Operator Email List",

        defaultVariableOrValue: `#*${VarKey.LocationswivlLeadEmailList}*#`,
      },
    },
  },

  {
    name: "receipt-passive-rating",

    templateDisplayName: "Receipt: Passive Rating",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userreviewnpsfeedback: {
        fieldName: "UserReviewNPSFeedback",

        displayName: "User Review NPS Feedback",

        defaultVariableOrValue: `#*${VarKey.UserReviewNPSFeedback}*#`,
      },

      userreviewnpsscore: {
        fieldName: "UserReviewNPSScore",

        displayName: "User Review NPS Score",

        defaultVariableOrValue: `#*${VarKey.UserReviewNPSScore}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userpostalcode: {
        fieldName: "UserPostalCode",

        displayName: "User Postal Code",

        defaultVariableOrValue: `#*${VarKey.UserPostalCode}*#`,
      },

      usercurrenturl: {
        fieldName: "UserCurrentURL",

        displayName: "User Current URL",

        defaultVariableOrValue: `#*${VarKey.UserCurrentURL}*#`,
      },

      transcripturl: {
        fieldName: "TranscriptURL",

        displayName: "Transcript URL",

        defaultVariableOrValue: `https://v3.swivl.studio/transcript/#*${VarKey.UserId}*#`,
      },

      conversationurl: {
        fieldName: "ConversationURL",

        displayName: "Conversation URL",

        defaultVariableOrValue: `https://v3.swivl.studio/conversations/all/#*${VarKey.UserId}*#`,
      },

      storeemail: {
        fieldName: "StoreEmail",

        displayName: "Store Email",

        defaultVariableOrValue: `#*${VarKey.LocationEmail}*#`,
      },

      storedmemail: {
        fieldName: "StoreDMEmail",

        displayName: "Store DM Email",

        defaultVariableOrValue: `#*${VarKey.LocationDMEmail}*#`,
      },

      operatoremaillist: {
        fieldName: "OperatorEmailList",

        displayName: "Operator Email List",

        defaultVariableOrValue: `#*${VarKey.LocationswivlLeadEmailList}*#`,
      },
    },
  },

  {
    name: "receipt-fms-general",

    templateDisplayName: "Receipt: FMS General",

    //Need to edit

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userpostalcode: {
        fieldName: "UserPostalCode",

        displayName: "User Postal Code",

        defaultVariableOrValue: `#*${VarKey.UserPostalCode}*#`,
      },

      usercurrenturl: {
        fieldName: "UserCurrentURL",

        displayName: "User Current URL",

        defaultVariableOrValue: `#*${VarKey.UserCurrentURL}*#`,
      },

      userquestion: {
        fieldName: "UserQuestion",

        displayName: "User Question",

        defaultVariableOrValue: `#*${VarKey.UserLastIntent}*#`,
      },

      userpersona: {
        fieldName: "UserPersona",

        displayName: "User Persona",

        defaultVariableOrValue: `#*${VarKey.UserPersona}*#`,
      },

      userfmsleadstatus: {
        fieldName: "UserFMSLeadStatus",

        displayName: "User FMS Lead Status",

        defaultVariableOrValue: `#*${VarKey.UserLeadStatus}*#`,
      }, // update this in workflows from 0/1 to unsuccessful/successful?

      // userfmserror is helpful, but maybe just for us

      storefmsid: {
        fieldName: "StoreFMSID",

        displayName: "Store FMS ID",

        defaultVariableOrValue: `#*${VarKey.LocationFMSId}*#`,
      },

      transcripturl: {
        fieldName: "TranscriptURL",

        displayName: "Transcript URL",

        defaultVariableOrValue: `https://v3.swivl.studio/transcript/#*${VarKey.UserId}*#`,
      },

      conversationurl: {
        fieldName: "ConversationURL",

        displayName: "Conversation URL",

        defaultVariableOrValue: `https://v3.swivl.studio/conversations/all/#*${VarKey.UserId}*#`,
      },

      storeemail: {
        fieldName: "StoreEmail",

        displayName: "Store Email",

        defaultVariableOrValue: `#*${VarKey.LocationEmail}*#`,
      },

      storedmemail: {
        fieldName: "StoreDMEmail",

        displayName: "Store DM Email",

        defaultVariableOrValue: `#*${VarKey.LocationDMEmail}*#`,
      },

      operatoremaillist: {
        fieldName: "OperatorEmailList",

        displayName: "Operator Email List",

        defaultVariableOrValue: `#*${VarKey.LocationswivlLeadEmailList}*#`,
      },
    },
  },

  {
    name: "receipt-lead-fms-fail",

    templateDisplayName: "Receipt: Lead FMS Fail",

    //Need to edit

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      fmstype: {
        fieldName: "FMSType",

        displayName: "FMS",

        defaultVariableOrValue: `#*${VarKey.LocationFMSType}*#`,
      },

      storefmsid: {
        fieldName: "StoreFMSID",

        displayName: "Store FMS ID",

        defaultVariableOrValue: `#*${VarKey.LocationFMSId}*#`,
      },

      userfmserror: {
        fieldName: "UserFMSError",

        displayName: "User FMS Error",

        defaultVariableOrValue: `#*${VarKey.UserFMSError}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userpostalcode: {
        fieldName: "UserPostalCode",

        displayName: "User Postal Code",

        defaultVariableOrValue: `#*${VarKey.UserPostalCode}*#`,
      },

      usercurrenturl: {
        fieldName: "UserCurrentURL",

        displayName: "User Current URL",

        defaultVariableOrValue: `#*${VarKey.UserCurrentURL}*#`,
      },

      userquestion: {
        fieldName: "UserQuestion",

        displayName: "User Question",

        defaultVariableOrValue: `#*${VarKey.UserLastIntent}*#`,
      },

      userpersona: {
        fieldName: "UserPersona",

        displayName: "User Persona",

        defaultVariableOrValue: `#*${VarKey.UserPersona}*#`,
      },

      transcripturl: {
        fieldName: "TranscriptURL",

        displayName: "Transcript URL",

        defaultVariableOrValue: `https://v3.swivl.studio/transcript/#*${VarKey.UserId}*#`,
      },

      conversationurl: {
        fieldName: "ConversationURL",

        displayName: "Conversation URL",

        defaultVariableOrValue: `https://v3.swivl.studio/conversations/all/#*${VarKey.UserId}*#`,
      },

      storeemail: {
        fieldName: "StoreEmail",

        displayName: "Store Email",

        defaultVariableOrValue: `#*${VarKey.LocationEmail}*#`,
      },

      storedmemail: {
        fieldName: "StoreDMEmail",

        displayName: "Store DM Email",

        defaultVariableOrValue: `#*${VarKey.LocationDMEmail}*#`,
      },

      operatoremaillist: {
        fieldName: "OperatorEmailList",

        displayName: "Operator Email List",

        defaultVariableOrValue: `#*${VarKey.LocationswivlLeadEmailList}*#`,
      },

      spacedimensions: {
        fieldName: "SpaceDimensions",

        displayName: "Space Dimensions",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      spacerate: {
        fieldName: "SpaceRate",

        displayName: "Space Rate",

        defaultVariableOrValue: `#*${VarKey.UnitRate}*#`,
      },

      spaceid: {
        fieldName: "SpaceID",

        displayName: "Space ID",

        defaultVariableOrValue: `#*${VarKey.UnitExternalUnitId}*#`,
      },
    },
  },

  {
    name: "receipt-lead-fms-success",

    templateDisplayName: "Receipt: Lead FMS Success",

    //Need to edit

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      fmstype: {
        fieldName: "FMSType",

        displayName: "FMS",

        defaultVariableOrValue: `#*${VarKey.LocationFMSType}*#`,
      },

      storefmsid: {
        fieldName: "StoreFMSID",

        displayName: "Store FMS ID",

        defaultVariableOrValue: `#*${VarKey.LocationFMSId}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userpostalcode: {
        fieldName: "UserPostalCode",

        displayName: "User Postal Code",

        defaultVariableOrValue: `#*${VarKey.UserPostalCode}*#`,
      },

      usercurrenturl: {
        fieldName: "UserCurrentURL",

        displayName: "User Current URL",

        defaultVariableOrValue: `#*${VarKey.UserCurrentURL}*#`,
      },

      userquestion: {
        fieldName: "UserQuestion",

        displayName: "User Question",

        defaultVariableOrValue: `#*${VarKey.UserLastIntent}*#`,
      },

      userpersona: {
        fieldName: "UserPersona",

        displayName: "User Persona",

        defaultVariableOrValue: `#*${VarKey.UserPersona}*#`,
      },

      transcripturl: {
        fieldName: "TranscriptURL",

        displayName: "Transcript URL",

        defaultVariableOrValue: `https://v3.swivl.studio/transcript/#*${VarKey.UserId}*#`,
      },

      conversationurl: {
        fieldName: "ConversationURL",

        displayName: "Conversation URL",

        defaultVariableOrValue: `https://v3.swivl.studio/conversations/all/#*${VarKey.UserId}*#`,
      },

      storeemail: {
        fieldName: "StoreEmail",

        displayName: "Store Email",

        defaultVariableOrValue: `#*${VarKey.LocationEmail}*#`,
      },

      storedmemail: {
        fieldName: "StoreDMEmail",

        displayName: "Store DM Email",

        defaultVariableOrValue: `#*${VarKey.LocationDMEmail}*#`,
      },

      operatoremaillist: {
        fieldName: "OperatorEmailList",

        displayName: "Operator Email List",

        defaultVariableOrValue: `#*${VarKey.LocationswivlLeadEmailList}*#`,
      },

      spacedimensions: {
        fieldName: "SpaceDimensions",

        displayName: "Space Dimensions",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      spacerate: {
        fieldName: "SpaceRate",

        displayName: "Space Rate",

        defaultVariableOrValue: `#*${VarKey.UnitRate}*#`,
      },

      spaceid: {
        fieldName: "SpaceID",

        displayName: "Space ID",

        defaultVariableOrValue: `#*${VarKey.UnitExternalUnitId}*#`,
      },
    },
  },

  {
    name: "swivlstudio-workflow-gate-code", // don't see this in mailchip

    templateDisplayName: "Gate Code Email",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      useraccesscode: {
        fieldName: "UserAccessCode",

        displayName: "Access/Gate Code",

        defaultVariableOrValue: `#*${VarKey.UserAccessCode}*#`,
      },
    },
  },

  {
    name: "upcoming-payment-reminder", // is this a dupe of fms-payment-reminder?

    templateDisplayName: "Upcoming Payment Reminder",

    mergeFields: {
      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      userunitsize: {
        fieldName: "UnitDimensions",

        displayName: "User Unit Size",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      balancedue: {
        fieldName: "BalanceDue",

        displayName: "Balance Due",

        defaultVariableOrValue: `#*${VarKey.LeaseBalance}*#`,
      },

      payonlineurl: {
        fieldName: "PayOnlineURL",

        displayName: "Pay Online URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true&swivlStartOnQuest=#*${VarKey.LocationAfterNavigateAccountLoginPayBillQuestSlug}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },
    },
  },

  {
    name: "fms-abandoned-cart",

    templateDisplayName: "FMS+: Abandoned Cart",

    mergeFields: {
      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      spacedimensions: {
        fieldName: "SpaceDimensions",

        displayName: "Space Dimensions",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      spacerate: {
        fieldName: "SpaceRate",

        displayName: "Space Rate",

        defaultVariableOrValue: `#*${VarKey.UnitRate}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      finishreservationurl: {
        fieldName: "FinishReservationURL",

        displayName: "Finish Reservation URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true&swivlStartOnQuest=RmzidGERQG`, // 💎 After: Show Inventory
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-referral",

    templateDisplayName: "FMS+: Referral",

    mergeFields: {
      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      pagetitle: {
        fieldName: "BotSpotReferralPageTitle",

        displayName: "Page Title",

        defaultVariableOrValue: `#*${VarKey.LocationSpotReferralPageTitle}*#`,
      },

      pagebody: {
        fieldName: "BotSpotReferralPageBody",

        displayName: "Page Body",

        defaultVariableOrValue: `#*${VarKey.LocationSpotReferralPageBody}*#`,
      },

      brandslug: {
        fieldName: "BotSpotBrandSlug",

        displayName: "spot Brand",

        defaultVariableOrValue: `#*${VarKey.LocationSpotBrandSlug}*#`,
      },

      userid: {
        fieldName: "userId",

        displayName: "User ID",

        defaultVariableOrValue: `#*${VarKey.UserId}*#`,
      },

      emailsubject: {
        fieldName: "BotSpotReferralShareEmailSubject",

        displayName: "Email Subject",

        defaultVariableOrValue: `#*${VarKey.LocationSpotReferralShareEmailSubject}*#`,
      },

      emailbody: {
        fieldName: "BotSpotReferralShareEmailBody",

        displayName: "Email Body",

        defaultVariableOrValue: `#*${VarKey.LocationSpotReferralShareEmailBody}*#`,
      },

      spotlocation: {
        fieldName: "StoreSpotLocationSlug",

        displayName: "spot Location",

        defaultVariableOrValue: `#*${VarKey.LocationSpotLocationSlug}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },

      brandimage: {
        fieldName: "BrandImage",

        displayName: "Brand Image",

        defaultVariableOrValue: `#*${VarKey.LocationBrandImage}*#`,
      },

      brandcolor: {
        fieldName: "BrandColor",

        displayName: "Brand Color",

        defaultVariableOrValue: `#*${VarKey.LocationBrandColor}*#`,
      },
    },
  },

  {
    name: "fms-account-number",

    templateDisplayName: "FMS+: Account Number",

    mergeFields: {
      operatorname: {
        fieldName: "OperatorName",

        displayName: "Operator Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      fullname: {
        fieldName: "FULLNAME",

        displayName: "Full Name",

        defaultVariableOrValue: `#*${VarKey.UserName}*#`,
      },

      accountnumber: {
        fieldName: "TenantAccountNumber",

        displayName: "Tenant Account Number",

        defaultVariableOrValue: `#*${VarKey.TenantAccountNumber}*#`,
      },

      userphone: {
        fieldName: "UserPhone",

        displayName: "User Phone",

        defaultVariableOrValue: `#*${VarKey.UserPhoneNumber}*#`,
      },

      useremail: {
        fieldName: "UserEmail",

        displayName: "User Email",

        defaultVariableOrValue: `#*${VarKey.UserEmail}*#`,
      },

      storename: {
        fieldName: "StoreName",

        displayName: "Store Name",

        defaultVariableOrValue: `#*${VarKey.LocationName}*#`,
      },

      storeaddress: {
        fieldName: "StoreAddress",

        displayName: "Store Address",

        defaultVariableOrValue: `#*${VarKey.LocationAddress}*#`,
      },

      storecity: {
        fieldName: "StoreCity",

        displayName: "Store City",

        defaultVariableOrValue: `#*${VarKey.LocationCity}*#`,
      },

      storestate: {
        fieldName: "StoreState",

        displayName: "Store State",

        defaultVariableOrValue: `#*${VarKey.LocationState}*#`,
      },

      storepostalcode: {
        fieldName: "StorePostalCode",

        displayName: "Store Postal Code",

        defaultVariableOrValue: `#*${VarKey.LocationPostalCode}*#`,
      },

      userunitnumber: {
        fieldName: "UnitNumber",

        displayName: "User Unit Number",

        defaultVariableOrValue: `#*${VarKey.UnitNumber}*#`,
      },

      userunitsize: {
        fieldName: "UnitDimensions",

        displayName: "User Unit Size",

        defaultVariableOrValue: `#*${VarKey.UnitDimensions}*#`,
      },

      chatwithusurl: {
        fieldName: "ChatWithUsURL",

        displayName: "Chat With Us URL",

        defaultVariableOrValue: `#*${VarKey.LocationWebsiteURL}*#/?swivlOpen=true`,
      },
    },
  },
];
